import {ATextEvent, OnTextChanged, TextEventType, TextSelection} from '@mintdata/mint-kit/api/models/Text';
import {DomUtils} from '@mintdata/mint-kit/impl/util/DomUtils';
import {StringUtil} from '@mintdata/mint-kit/impl/util/StringUtil';
import {bind} from 'bind-decorator';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('@mintdata-wsp/wsp/ui/views/visualDesigner/spreadsheet/input/FormulaInput.less');

interface IFormulaInputProps
{
    onTextChanged:OnTextChanged;
    onSelectionChanged:OnTextChanged;
    onPaste:(textToPaste:string) => (void);
    onRef:(inputElement:HTMLElement) => void;
}

@observer
export class FormulaInput extends React.Component<IFormulaInputProps, any>
{
    private _element:HTMLElement = null;

    @bind
    private _onElementRef(element:HTMLDivElement):void
    {
        const {onRef} = this.props;

        this._element = element;

        if( onRef )
            onRef(element);
    }

    @bind
    private _onInput(event:React.FormEvent<HTMLDivElement>):void
    {
        const {onTextChanged} = this.props;

        if( this._element && onTextChanged)
        {
            const textContent:string = DomUtils.getTextContent(this._element);
            const selection:TextSelection = DomUtils.getSelection(this._element);

            const te = new ATextEvent(
                TextEventType.TextChanged,
                null,
                textContent,
                selection,
            );

            onTextChanged(te);
        }
    }

    @bind
    private _onSelect(event:React.SyntheticEvent<HTMLDivElement>):void
    {
        const {onSelectionChanged} = this.props;

        if( this._element && onSelectionChanged )
        {
            const selection:TextSelection = DomUtils.getSelection(this._element);

            const te = new ATextEvent(
                TextEventType.SelectionChanged,
                null,
                null,
                selection,
            );

            onSelectionChanged(te);
        }
    }

    @bind
    private _onPaste(event:React.ClipboardEvent<HTMLDivElement>):void
    {
        if( event.clipboardData && event.clipboardData.getData )
        {
            let textToPaste:string = event.clipboardData.getData('text/plain')
                .replace(/\u00a0/g, ' ');
            textToPaste = StringUtil.replaceUnicodeQuotesIntoASCII(textToPaste);

            this.props.onPaste(textToPaste);
        }

        event.preventDefault();
        event.stopPropagation();
    }

    public render():JSX.Element
    {
        return React.createElement('div',
            {
                autoComplete: 'off',
                autoCorrect: 'off',
                autoCapitalize: 'off',
                spellCheck: false,
                ref: this._onElementRef,
                contentEditable: true,
                className: styles.formulaInput,
                onInput: this._onInput,
                onSelect: this._onSelect,
                onPasteCapture: this._onPaste,
            });
    }
}
